// eslint-disable-next-line jira/filename-case
import React from 'react';
import { ScreenRedirect } from '@jira/platform__routing-screen-redirect/src/ui/ScreenRedirect.tsx';

export const redirectTo = (redirectUrl: string) => (): React.JSX.Element => (
	<ScreenRedirect to={redirectUrl} />
);
